import React, { useState } from "react";
import cvOptimizer from "../../assets/requestAccess/cvOptimizer.svg";
import mockTest from "../../assets/requestAccess/mockTest.svg";
import mockInterview from "../../assets/requestAccess/mockInterview.svg";
import aiInsights from "../../assets/requestAccess/aiInsights.svg";
import RequestAccessModal from "./RequestAccessModal";

const moduleConfig = {
  CV_OPTIMIZER: {
    img: cvOptimizer,
    heading: "Hey, want a smarter CV that stands out?",
    description:
      "Optimize and polish your CV with AI-powered feedback on format, content, and tone — highlight key strengths, fix hidden gaps, and tailor it for ATS. Turn your resume into a job-winning document that stands out to recruiters and lands more interviews with confidence.",
  },
  MOCK_TEST: {
    img: mockTest,
    heading: "Ready to Test Your Skills?",
    description:
      "Practice with tests modeled on real company assessments - aptitude, technical, and case-based - so you mirror actual job patterns instead of random quizzes. This way, you walk into employer tests with familiarity, not fear, knowing the format, difficulty level, and exactly where you stand compared to peers.",
  },
  MOCK_INTERVIEW: {
    img: mockInterview,
    heading: "Want to crack your next interview like a pro?",
    description:
      "Simulate real interviews with AI or structured scripts and face role-specific, company-contextualized questions that recruiters actually ask — instead of generic “common questions.” With immediate feedback to refine your answers, you’ll build confidence, sharpen communication, and reduce the chances of rejection due to unpreparedness.",
  },
  IN_SIGHT: {
    img: aiInsights,
    heading: "Smarter Prep Starts with AI Insights",
    description:
      "Get personalized insights into your strengths, gaps, and how employers see you—tailored to your role. Focus on the 20% that drives 80% of results, cutting months of trial-and-error prep.",
  },
};

function RequestAccess({ moduleName, svgSize, noMaxHeight }) {
  const [openRequestModal, setOpenRequestModal] = useState(false);
  const content = moduleConfig[moduleName];

  const closeModal = () => {
    setOpenRequestModal(false);
  };

  return (
    <>
      {openRequestModal && (
        <RequestAccessModal
          openModal={openRequestModal}
          closeModal={closeModal}
          moduleName={moduleName}
        />
      )}
      <div
        className={` ${
          noMaxHeight ? "" : "min-h-[85vh]"
        }  flex flex-col justify-center items-center px-2 py-[.85rem]`}
      >
        <div className="max-w-lg border border-[#D0D5DD] rounded-xl shadow-lg mx-auto px-8 py-6 flex flex-col gap-[.42rem] items-center justify-center text-center">
          <>
            <img src={content?.img} width={svgSize} alt={`${moduleName}-img`} />
            <div className="text-[#0F1B23] font-semibold text-[1.2rem]">
              {content?.heading}
            </div>
            <div className="text-[#475467] w-[96%] mx-auto font-medium text-[.94rem]">
              {content?.description}
            </div>
            <button
              onClick={() => setOpenRequestModal(true)}
              className="btn-orange flex justify-center items-center gap-[.65rem] mt-[.45rem] font-semibold px-3 w-full py-2 text-[.9rem]"
            >
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.6667 7.49995C14.6667 7.07343 14.5039 6.64691 14.1785 6.32149C13.8531 5.99605 13.4265 5.83333 13 5.83333M13 12.5C15.7614 12.5 18 10.2614 18 7.5C18 4.73858 15.7614 2.5 13 2.5C10.2386 2.5 8 4.73858 8 7.5C8 7.72807 8.01527 7.95256 8.04484 8.17253C8.09348 8.53432 8.1178 8.71521 8.10143 8.82966C8.08438 8.94888 8.06267 9.01312 8.00391 9.11825C7.9475 9.21917 7.84809 9.31857 7.64928 9.51739L3.39052 13.7761C3.2464 13.9203 3.17433 13.9923 3.1228 14.0764C3.07711 14.151 3.04344 14.2323 3.02303 14.3173C3 14.4132 3 14.5151 3 14.719V16.1667C3 16.6334 3 16.8667 3.09083 17.045C3.17072 17.2018 3.29821 17.3293 3.45501 17.4092C3.63327 17.5 3.86662 17.5 4.33333 17.5H6.33333V15.8333H8V14.1667H9.66667L10.9826 12.8507C11.1814 12.6519 11.2808 12.5525 11.3818 12.4961C11.4869 12.4373 11.5511 12.4156 11.6703 12.3986C11.7848 12.3822 11.9657 12.4065 12.3275 12.4552C12.5474 12.4847 12.7719 12.5 13 12.5Z"
                  stroke="#0F1B23"
                  stroke-width="1.67"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Request Access to Unlock This Feature
            </button>
          </>
        </div>
      </div>
    </>
  );
}

export default RequestAccess;
